import ApiService from "../../config/api-config";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import { useState } from "react";

import { useI18n } from "../../i18n/useI18n";
import MiniChat from "./MiniChat";
import css from "../commonMagneticStyle.less";

//assets
import { lensLogo } from "@harbor/elements/icons";

const [
    HbrButton, HbrMenu, HbrMenuItem, HbrSpinner,
    HbrDropdown, HbrModal, HbrMarkdown, HbrIcon]
    = reactWrapper([
        "hbr-button",
        "hbr-menu",
        "hbr-menu-item",
        "hbr-spinner",
        "hbr-dropdown",
        "hbr-modal",
        "hbr-markdown",
        "hbr-icon"
    ])

const ExplainWidget = ({ payload, widget }) => {
    const { tCommon } = useI18n('common');
    const [showSpinner, setShowSpinner] = useState(false);
    const [chatSpinner, setChatSpinner] = useState(false);
    const [showChatWindow, setShowChatWindow] = useState(false);
    const [message, setMessage] = useState("");
    const [chatError, setChatError] = useState(false);
    const [thread, setThread] = useState(null);

    const _onClickClose = () => {
        setMessage("");
        setShowSpinner(false);
    }

    const onExplain = async () => {
        // This function is called when the intel icon is clicked
        setShowSpinner(true);

        try {
            const response = await ApiService.explainWidget(payload, widget);
            setMessage(response?.data?.message || tCommon('explainWidgetSomething'));
        } catch (error) {
            setMessage(tCommon('explainWidgetChatError'));
        }
    }

    const explainChat = async (input) => {
        const initValue = thread ? thread : [];
        setChatSpinner(true);

        try {
            const response =
                await ApiService.explainWidget(payload, input)
            const prompt = [...initValue, { query: input, response: response.data.message }]

            setThread(prompt);
            setChatSpinner(false);
        } catch (error) {
            setChatError(tCommon('explainWidgetChatError'));
        }
    }

    const onChat = () => {
        setShowChatWindow(true);
    }

    const onCloseChat = () => {
        setShowChatWindow(false);
        setThread(null);
    }
    return (
        <div className={`${css["explain-widget"]} hbr-css__layout-col-sm `}>
            <div className="hbr-css__layout-row-md">
                {showSpinner === false &&
                    <HbrDropdown menu>
                        <HbrButton slot="trigger" caret variant="text">
                            <HbrIcon
                                slot="prefix"
                                asset={lensLogo}
                                staticColors="true"
                                size="18px"
                            ></HbrIcon>
                            {tCommon('explainWidget')}
                        </HbrButton>
                        <HbrMenu>
                            <HbrMenuItem value="explain" onClick={onExplain}>{tCommon('explainWidgetExplain')}</HbrMenuItem>
                            <HbrMenuItem value="chat-window" disabled onClick={onChat}>{tCommon('explainWidgetChatPlaceholder')}</HbrMenuItem>
                        </HbrMenu>
                    </HbrDropdown>}
                {message !== "" &&
                    <HbrModal
                        label={tCommon('explainWidgetSummary')}
                        open={true}
                    >
                        <div className="explain-widget-explain">
                            <HbrMarkdown
                                content={message} />
                        </div>
                        <div
                            slot="footer"
                            className="hbr-css__layout-row-md hbr-css__layout-justify-end"
                        >
                            <HbrButton variant="text" onClick={_onClickClose}>
                                {tCommon('explainWidgetOK')}
                            </HbrButton >
                        </div >
                    </HbrModal >
                }
                {
                    showSpinner && message === "" &&
                    <HbrButton variant="text" disabled={true}>
                        <HbrSpinner slot="prefix" />
                        {tCommon('explainWidgetChatLoading')}
                    </HbrButton>}
            </div >
            {showChatWindow &&
                <MiniChat
                    explainChat={explainChat}
                    onCloseChat={onCloseChat}
                    miniState={
                        {
                            spinner: chatSpinner,
                            showChatWindow: showChatWindow,
                            thread: thread,
                            error: chatError
                        }
                    }
                />}
        </div >
    )
}

import PropTypes from "prop-types";
ExplainWidget.propTypes = {
    payload: PropTypes.object.isRequired,
    widget: PropTypes.string.isRequired
};
export default ExplainWidget;
